"use client";
import {MessageCircle} from 'lucide-react';
import type {ComponentPropsWithRef} from 'react';
import './atlas-control.css';

// One identity and launcher for home, questionnaires, and Profile Center.
export function AtlasIcon({size=22}:{size?:number}) {
 return <MessageCircle size={size} strokeWidth={1.8} aria-hidden="true"/>;
}

export function AtlasLauncher({className='',...props}:ComponentPropsWithRef<'button'>) {
 return <button {...props} type="button" className={`atlas-launcher ${className}`} title={props['aria-label']}><AtlasIcon/></button>;
}
